// extracted by mini-css-extract-plugin
export default {"fullscreenControlWrapper":"styles_fullscreenControlWrapper__UNiXN","fullscreenControl":"styles_fullscreenControl__5bo1G"};